export default __webpack_public_path__ + "static/media/phasor-introduction.feae4ef3.gif";